import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M42.013 22.536c.004-2.172.004-3.77-.002-4.72A3 3 0 0 0 44 14.993V11.3a5 5 0 0 0-4.805-4.996 387 387 0 0 0-15.015-.268q-8.223 0-15.371.274A5 5 0 0 0 4 11.306V15a3 3 0 0 0 1.99 2.817c-.007.95-.007 2.548-.003 4.72l.005 2.272.006 1.991L6 28.018q0 3.953.188 6.93a7 7 0 0 0 6.409 6.536q6.671.552 11.454.552 4.767 0 11.355-.549a7 7 0 0 0 6.406-6.534q.188-2.98.188-6.935l.002-1.214.006-1.991zM16 21v-3H7.988c-.005.954-.005 2.496-.001 4.533l.005 2.27.005 1.992L8 28.018q0 3.893.184 6.804a5 5 0 0 0 4.578 4.669q6.595.545 11.29.545 4.677 0 11.188-.542a5 5 0 0 0 4.576-4.667q.183-2.913.184-6.81l.002-1.218.006-1.991.005-2.276c.004-2.036.004-3.579-.001-4.532H32v3a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3M8.885 8.308A3 3 0 0 0 6 11.306v3.69a1 1 0 0 0 1.004.995q10.4-.04 13.66-.008c1.148.011 5.58.011 6.71 0 2.175-.02 6.714-.018 13.626.009a1 1 0 0 0 1-1V11.3a3 3 0 0 0-2.883-2.997 385 385 0 0 0-14.937-.267q-8.187 0-15.295.272M18 21v-3h12v3a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Archive-Outlined_svg__a",
      width: 40,
      height: 37,
      x: 4,
      y: 6,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M42.013 22.536c.004-2.172.004-3.77-.002-4.72A3 3 0 0 0 44 14.993V11.3a5 5 0 0 0-4.805-4.996 387 387 0 0 0-15.015-.268q-8.223 0-15.371.274A5 5 0 0 0 4 11.306V15a3 3 0 0 0 1.99 2.817c-.007.95-.007 2.548-.003 4.72l.005 2.272.006 1.991L6 28.018q0 3.953.188 6.93a7 7 0 0 0 6.409 6.536q6.671.552 11.454.552 4.767 0 11.355-.549a7 7 0 0 0 6.406-6.534q.188-2.98.188-6.935l.002-1.214.006-1.991zM16 21v-3H7.988c-.005.954-.005 2.496-.001 4.533l.005 2.27.005 1.992L8 28.018q0 3.893.184 6.804a5 5 0 0 0 4.578 4.669q6.595.545 11.29.545 4.677 0 11.188-.542a5 5 0 0 0 4.576-4.667q.183-2.913.184-6.81l.002-1.218.006-1.991.005-2.276c.004-2.036.004-3.579-.001-4.532H32v3a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3M8.885 8.308A3 3 0 0 0 6 11.306v3.69a1 1 0 0 0 1.004.995q10.4-.04 13.66-.008c1.148.011 5.58.011 6.71 0 2.175-.02 6.714-.018 13.626.009a1 1 0 0 0 1-1V11.3a3 3 0 0 0-2.883-2.997 385 385 0 0 0-14.937-.267q-8.187 0-15.295.272M18 21v-3h12v3a1 1 0 0 1-1 1H19a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Archive-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgArchiveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArchiveOutlined_default = SvgArchiveOutlined;

export { ArchiveOutlined_default as default };
